class DiscountCodeForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector( "#discount-input-form" );
        this.discountInputField = this.querySelector( "#discount-code" );
        this.discountSubmit = this.querySelector( "[data-submit]" );
        this.discountBadgesContainer = this.querySelector( ".applied-discounts-container" );
        this.htmlTemplates = window.cart_discounts.templates;

        this.init();
    }

    init() {
        if ( this.form != null ) {
            this.form.addEventListener( 'submit' , this.submitDiscountCode.bind( this ) );
        }

        this.loadDiscountCodes();
    }

    async loadDiscountCodes() {
        this.discountBadgesContainer.classList.add( "loading" );
        this.discountBadgesContainer.innerHTML = "";

        const graphqlCart = await getCartGraphQL();
        const discountCodes = graphqlCart.data.cart.discountCodes;

        for ( let i = 0; i < discountCodes.length; i++ ) {
            const displayName = discountCodes[i].code;
            const isApplicable = discountCodes[i].applicable;

            // dont display codes that are not valid
            if ( !isApplicable ) {
                continue;
            }

            let template = this.htmlTemplates["badge"];
            template = template.replaceAll( "[[DISCOUNT_NAME]]" , displayName );
            this.discountBadgesContainer.innerHTML += template;
        }

        this.discountBadgesContainer.classList.remove( "loading" );

        return;
    }

    async submitDiscountCode( event ) {
        event.preventDefault();

        const currentCart = await getCartGraphQL();
        const discountCodes = currentCart.data.cart.discountCodes;
        const discountCodesToSend = [];
        for ( let i = 0; i < discountCodes.length; i++ ) {
            discountCodesToSend.push( discountCodes[i].code );
        }

        discountCodesToSend.push( this.discountInputField.value );
        
        await applyCartDiscountCodes( "2025-07" , discountCodesToSend , true );
    }
}

customElements.define( 'discount-code-form', DiscountCodeForm );

class DiscountCodeBadges extends HTMLElement {
    connectedCallback() {
        console.log( 'BADGE INIT' );
        this.removeButton = this.querySelector( "[data-discount-to-remove]" );
        this.codeToRemove = "";

        this.init();
    }

    init() {
        if ( this.removeButton != null ) {
            this.codeToRemove = this.removeButton.getAttribute( "data-discount-to-remove" );
            this.removeButton.addEventListener( 'click' , this.removeDiscount.bind( this ) );
        }
    }

    async removeDiscount( event ) {
        const currentCart = await getCartGraphQL();
        const discountCodes = currentCart.data.cart.discountCodes;
        const discountCodesToSend = [];
        for ( let i = 0; i < discountCodes.length; i++ ) {
            if ( this.codeToRemove == discountCodes[i].code ) {
                continue;
            }

            discountCodesToSend.push( discountCodes[i].code );
        }
        
        await applyCartDiscountCodes( "2025-07" , discountCodesToSend , true );
    }
}

customElements.define( 'discount-code-badge', DiscountCodeBadges );


async function applyCartDiscountCodes( apiVersion = "2025-07" , discountCodes = [] , refreshCart = true ) {
    let applied = false;

    try {
        const discountQuery = `
        mutation cartDiscountCodesUpdate( $cartId: ID!, $discountCodes: [String!] ) {
            cartDiscountCodesUpdate( cartId: $cartId, discountCodes: $discountCodes ) {
                cart {
                    id
                    appliedGiftCards {
                        id
                        lastCharacters
                    }
                    discountCodes {
                        applicable
                        code
                    }
                }
                userErrors {
                    field
                    message
                    code
                }
                warnings {
                    message
                    code
                    target
                }
            }
        }`;

        const cartToken = await getCartToken();
        const decodedCartToken = decodeURI( cartToken );

        const variables = {
            cartId: `gid://shopify/Cart/${decodedCartToken}`,
            discountCodes: discountCodes
        };

        const shop = window.Shopify.shop;
        const requestUrl = `https://${shop}/api/${apiVersion}/graphql.json`;
        const requestSettings = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: discountQuery,
                variables: variables
            })
        };
        
        const response = await fetch( requestUrl , requestSettings );
        const data = await response.json();

        if ( data?.errors?.length > 0 ) {
            throw new Error( JSON.stringify( data.errors ) );
        } else {
            applied = true;
        }
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to apply discount codes to the cart! See reported error for details.' );
    }

    if ( refreshCart ) {
        try {
            reloadCart();
        } catch ( error ) {
            console.warn( error );
        }

        try {
            reloadCartPage();
        } catch ( error ) {
            console.warn( error );
        }
    }

    return applied;
}

async function getCartGraphQL( apiVersion = "2025-07" ) {
    let graphqlCart = null;
    
    try {
        const cartQuery = `
            query GetCart( $cartId: ID! ) {
                cart(
                    id: $cartId
                ) {
                    id
                    totalQuantity
                    cost {
                        subtotalAmountEstimated
                        totalAmountEstimated
                        checkoutChargeAmount {
                            amount
                        }
                        subtotalAmount {
                            amount
                        }
                        totalAmount {
                            amount
                        }
                    }
                    appliedGiftCards {
                        lastCharacters
                        amountUsed {
                            amount
                        }
                        balance {
                            amount
                        }
                        presentmentAmountUsed {
                            amount
                        }
                    }
                    discountCodes {
                        applicable
                        code
                    }
                }
            }
        `;

        const cartToken = await getCartToken();
        const decodedCartToken = decodeURI( cartToken );
        const variables = {
            cartId: `gid://shopify/Cart/${decodedCartToken}`
        };

        const shop = window.Shopify.shop;
        const requestUrl = `https://${shop}/api/${apiVersion}/graphql.json`;
        const requestSettings = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: cartQuery,
                variables: variables
            })
        };
        
        const response = await fetch( requestUrl , requestSettings );
        const data = await response.json();

        if ( data?.errors?.length > 0 ) {
            throw new Error( JSON.stringify( data.errors ) );
        } else {
            graphqlCart = data;
        }
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to get cart id for current cart token.' );
    }

    return graphqlCart;
}

async function getCartToken( ) {
    let token = null;

    try {
        const response = await fetch( '/cart.json' );
        const cart = await response.json();
        token = cart.token;
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to get cart token from /cart.json' );
    }

    return token;
}

async function getCartTokenLocalStorage( ) {
    let token = null;
    token = localStorage.getItem( "cartToken" );
    return token;
}

async function reloadCart( ) {
    const sectionId = "cart-drawer";
    const loading = new window.FoxTheme.AnimateLoading( 
        document.querySelector( sectionId ), 
        { 
            overlay: document.querySelector( sectionId ) 
        }
    );

    try {
        loading.start();

        const url = `/?sections=${sectionId}`;
        const response = await fetch( url );
        const sections = await response.json();
        const html = sections[ sectionId ];
        const domParser = new DOMParser().parseFromString( html, 'text/html' );
        const newInnerHTML = domParser.querySelector( '.f-cart-drawer__inner' );
        const cartDrawer = document.querySelector( 'cart-drawer' );

        if ( cartDrawer != null && newInnerHTML != null ) {
            cartDrawer.innerHTML = null;
            cartDrawer.innerHTML = newInnerHTML.outerHTML;

            // refresh promo if it exists
            if ( window?.freePromoSystem?.runPromoSystem ) {
                await window.freePromoSystem.runPromoSystem();
                loading.finish();
            }

            const discountTab = document.querySelector( `[data-block-id="collapsible-tab-discount-form-collapsable"]` );
            if ( discountTab != null ) {
                discountTab.expand();
            }
        }
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to get the cart-drawer section' );
    } finally {
        loading.finish();
    }
}

async function reloadCartPage( ) {
    const sectionIds = [
        { 
            selector: ".main-cart-items-section .cart-items-section" , 
            innerSelector: ".cart-items-section-wrapper",
            sectionId: "main-cart-items" 
        }, 
        { 
            selector: `#main-cart-footer .f-cart__addons .discount-code-block .collapsible__content`, 
            innerSelector: `.collapsible__content-inner`,
            sectionId: "main-cart-footer",
        } 
    ];

    for ( let i = 0; i < sectionIds.length; i++ ) {
        const sectionSelector = sectionIds[i].selector;
        const sectionId = sectionIds[i].sectionId;
        const innerSelector = sectionIds[i].innerSelector;

        const loading = new window.FoxTheme.AnimateLoading( 
            document.querySelector( sectionSelector ), 
            { 
                overlay: document.querySelector( sectionSelector ) 
            }
        );

        // we do this to allow both sections to reload at the same time instead of sequentially
        async function handleReloadForSection() {
            try {
                loading.start();

                const url = `/?sections=${sectionId}`;
                const response = await fetch( url );
                const sections = await response.json();
                const html = sections[ sectionId ];
                const domParser = new DOMParser().parseFromString( html, 'text/html' );
                const newInnerHTML = domParser.querySelector( sectionSelector + ' ' + innerSelector );
                const sectionToUpdate = document.querySelector( sectionSelector );

                if ( sectionToUpdate != null && newInnerHTML != null ) {
                    sectionToUpdate.innerHTML = null;
                    sectionToUpdate.innerHTML = newInnerHTML.outerHTML;
                    loading.finish();

                    // on expand when we are updating it
                    const discountTab = document.querySelector( `[data-block-id="collapsible-tab-discount-form-collapsable"]` );
                    if ( discountTab != null ) {
                        discountTab.expand();
                    }
                        
                }
            } catch ( error ) {
                console.error( error );
                console.log( '[Cart Discount Codes] Failed to get the cart-drawer section' );
            } finally {
                loading.finish();
            }
        }

        handleReloadForSection();
    }
    
}